import { render, staticRenderFns } from "./CreateEmployeeEditor.vue?vue&type=template&id=37043960&scoped=true&"
import script from "./CreateEmployeeEditor.vue?vue&type=script&lang=js&"
export * from "./CreateEmployeeEditor.vue?vue&type=script&lang=js&"
import style0 from "./CreateEmployeeEditor.vue?vue&type=style&index=0&id=37043960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37043960",
  null
  
)

export default component.exports